import React, { useState, useEffect } from "react";
import axios from "axios";
import { getBaseUrl } from "../utils";
import { useLocation, useNavigate } from "react-router-dom";

const MaterialList = () => {
  const [subjects, setSubjects] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [activeSubject, setActiveSubject] = useState(null);
  // PDF is the default tab when study material opens
  const [fileType, setFileType] = useState("PDF");
  const { state } = useLocation();
  const navigate = useNavigate();
  const subjectIdFromState = state?.subjectId;
  const baseUrl = getBaseUrl();
  const token = localStorage.getItem("userToken");

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const response = await axios.get(`${baseUrl}user_api/subjectList`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data?.results) {
          setSubjects(response.data.results);
          // setActiveSubject(subjectIdFromState || response.data.results[0]?._id);
          const savedSubject = localStorage.getItem("selectedSubject");

          const subjectExists = response.data.results.find(
  (item) => item._id === savedSubject
);

setActiveSubject(
  subjectIdFromState ||
  savedSubject ||
  response.data.results[0]?._id
);
        }
      } catch (error) {
        console.error("Error fetching subjects:", error);
      }
    };

    fetchSubjects();
  }, [baseUrl, token, subjectIdFromState]);

  useEffect(() => {
    const fetchMaterials = async () => {
      if (!activeSubject) return;

      try {
        const response = await axios.get(
          `${baseUrl}user_api/studyMaterialList?subjectId=${activeSubject}&fileType=${fileType}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setMaterials(response.data?.results || []);
      } catch (error) {
        console.error("Error fetching materials:", error);
        setMaterials([]);
      }
    };

    fetchMaterials();
  }, [activeSubject, fileType, baseUrl]);

  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-gray-100">
      {/* Sidebar */}
      <aside className="w-full md:w-1/4 bg-gray-100 p-2">
        <ul className="space-y-4">
          {subjects.map((subject) => (
            <li
              key={subject._id}
              className={`flex items-center p-2 rounded-lg cursor-pointer shadow-sm transition ${activeSubject === subject._id
                ? "border-1 border-black bg-black text-white shadow-lg"
                : "bg-white hover:shadow-md"
                }`}
              // onClick={() => setActiveSubject(subject._id)}
              onClick={() => {
  setActiveSubject(subject._id);
  localStorage.setItem("selectedSubject", subject._id);
}}
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-full mr-3 bg-gray-200">
                📚
              </span>
              <span className="font-semibold">{subject.name}</span>
            </li>
          ))}
        </ul>
      </aside>

      {/* Main Content */}
      <div className="w-full md:flex-1 p-2">
        <div className="bg-white shadow-sm rounded-lg p-4 md:p-6">
          {/* Tabs */}
          <div className="flex flex-wrap border-b border-gray-300 mb-4">
            <button
              className={`px-4 py-2 font-medium ${fileType === "PDF"
                ? "border-b-2 border-black text-black"
                : "text-gray-500"
                }`}
              onClick={() => setFileType("PDF")}
            >
              PDF
            </button>
            <button
              className={`px-4 py-2 font-medium ${fileType === "Video"
                ? "border-b-2 border-black text-black"
                : "text-gray-500"
                }`}
              onClick={() => setFileType("Video")}
            >
              Video
            </button>
          </div>

          {/* Material Grid */}
          {materials.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {materials.map((material) => (
                <div
                  key={material._id}
                  className="shadow rounded-lg overflow-hidden cursor-pointer hover:shadow-xl"
                  onClick={() => navigate("/material-detail", { state: { material } })}
                >
                  {fileType === "PDF" ? (
                    <div className="flex items-start bg-white shadow-md rounded-lg p-4 space-x-2">
                      <div className="w-[50px] flex-shrink-0 flex items-center justify-center">
                        <img
                          src={material?.image}
                          alt="PDF Icon"
                          className="w-full h-full object-contain border"
                        />
                        {
                          console.log('materialmaterialmaterial',)
                        }
                      </div>
                      <div className="flex-1">
                        <h2 className="text-gray-900 font-bold text-base">{material.name || "Untitled"}</h2>
                      </div>
                    </div>
                  ) : (
                    <div>
                        <img
                        src={material.image || "/assets/default-image.png"}
                        alt={material.name}
                        className="w-full h-40 object-cover"
                      />
                      <div className="p-4">
                        <h2 className="text-lg font-semibold">{material.name || "Untitled"}</h2>
                        <div
                          className="text-gray-600 text-sm"
                          dangerouslySetInnerHTML={{
                            __html: material.description || "No description available.",
                          }}
                        ></div>

                        <p className="text-gray-500 text-xs mt-2">{material?.duration} minutes</p>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-500 text-center">No materials available</p>
          )}
        </div>
      </div>
    </div>

  );
};

export default MaterialList;